// extracted by mini-css-extract-plugin
export var footer = "_ph-5";
export var fulfillmentInput = "_ph-0";
export var shipDateInput = "_ph-1";
export var shipmentModal = "_ph-2";
export var shipmentModalContent = "_ph-3";
export var tableContainer = "_ph-4";